<template>
  <div>
    <div v-if="submittedReport" class="success-bar floating">{{t("Report submitted successfully")}}</div>
    <div v-if="submittedWeighting" class="success-bar floating">{{t("Weighting submitted successfully")}}</div>
    <div v-if="submittedMeasurement" class="success-bar floating">{{t("Measurement submitted successfully")}}</div>
    <PlanEnded v-if="planEnded" />
    <div class="container-m" v-if="planStarted">
      <FollowupFeed v-if="isFollowupPlan" />
      <FeedItems :items="items" today-report-hour="19:30" :login="login"
                 :show-learned-tasks="true" v-if="!planEnded && !isFollowupPlan" :completed-weightings="completedWeightings" :completed-measurements="completedMeasurements"
                 :completed-report-days="completedReportDays" :days-in-plan="daysInPlan" :on-quiz-click="onQuizClick"
                 :on-toggle-watch-video="onToggleWatchVideo" :on-weighting-click="onWeightingClick" :on-measurement-click="onMeasurementClick"
                 :plan-start-stats="planStartStats"
                 :dated-items="datedItems" :watched-videos="watchedVideos" :planStartDate="planStartDateRaw" :debug="showDebug"
                  @uploadProfileImage="onUploadProfileImage" @uploadSecondProfileImage="onUploadSecondProfileImage"
      />
    </div>
    <div v-else-if="inited && !planStarted" class="before-plan-start">
      <h1>{{t('The plan will start on {0}',planStartDate)}}</h1>
      <p>{{t("Meanwhile, check our introduction video")}}</p>
      <Vimeo path="806717268" />
    </div>
  </div>
</template>

<script>

import t from '@/lib/Locale';
import Fito from "@/lib/fito";
import Vimeo from "@/components/ui/widgets/Vimeo.vue";
import FeedItems from "@/components/ui/plan/FeedItems.vue";
import moment from "moment";
import PlanEnded from "@/components/ui/plan/PlanEnded.vue";
import FollowupFeed from "@/components/ui/plan/FollowupFeed.vue";
import {isInPlan, isInPlanOrTrainerMode, Plan_100, Plan_followup, Plan_trainers} from "@/lib/PlanUtils";

const TotalPlanDays = 100;

export default {
  name: "FeedHome",
  components: {FollowupFeed, PlanEnded, FeedItems, Vimeo},
  props: ['meta'],

  data() {
    return {
      datedItems : [],
      inited: false,
      submittedReport: false,
      submittedWeighting: false,
      submittedMeasurement: false,
      items : [],
      completedReportDays: [],
      completedWeightings: [],
      completedMeasurements: [],
      planStartStats: {},
      list: null,
      planStarted: false,
      planStartDate: t("next week"),
      planStartDateRaw: '2023-03-12',
      daysInPlan: 0,
      showDebug: false,
      isFollowupPlan: false,
      planEnded: false,
      watchedVideos: [],
      login: null,
    }
  },

  async mounted() {
    const login = await Fito().Login.safeCheckLogin(true)
    if (!login) return this.$router.push('/plan/login')

    this.login = login

    if (login.meta['watched-lessons']) {
      this.watchedVideos = login.meta['watched-lessons']
    }

    if (window.location.search.includes('submitted_report')) {
      this.submittedReport = true
      setTimeout(() => {
        this.submittedReport = false
      }, 5000)
    }

    if (window.location.search.includes('submitted_weighting')) {
      this.submittedWeighting = true
      setTimeout(() => {
        this.submittedWeighting = false
      }, 5000)
    }

    if (window.location.search.includes('submitted_measurement')) {
      this.submittedMeasurement = true
      setTimeout(() => {
        this.submittedMeasurement = false
      }, 5000)
    }

    this.isFollowupPlan = isInPlanOrTrainerMode(login, Plan_followup, 'followup') && login.daysInPlan > TotalPlanDays
    this.planEnded = login.daysInPlan > TotalPlanDays && !isInPlan(login, [Plan_followup, Plan_trainers])

    let startDate = login.subscriber.plan_start_date ? login.subscriber.plan_start_date : new Date().toString()
    this.setDates(startDate , login.daysInPlan)

    if (window.location.search === '?ok') this.planStarted = true

    let reports = login.meta.reports || [];
    this.completedReportDays = reports.map(it => it.day*1);

    let weightings = login.meta.weightings || [];
    this.completedWeightings = weightings.map(it => it.day*1);

    let measurements = login.meta.waist_measure || [];
    this.completedMeasurements = measurements.map(it => it.day*1);

    this.planStartStats = login.meta.plan_start_stats || {};

    let feed;

    if (isInPlanOrTrainerMode(login, Plan_100, 'hundred')) {
      feed = await Fito().loadSheet("videos-100-plan")
      feed = feed.map(a => ({
        'title': a[0],
        'content': a[1],
        'min_plan_days': (a[2]*1),
        // 'max_days_in_plan': a[3],
        'media_path': a[4],
        'media_type':'vimeo',
        'alt_media_path': a[5],
        'image': a[6],
      }))

      // if day is 1, make the videos starting with "1" in title appear last
      feed = feed.sort((a,b) => a.min_plan_days === 1  && b.min_plan_days === 1 ?
        a.title[0] === '1' && b.title[0] === '1' ? 0 : a.title[0] === '1' ? 1 : -1 : a.min_plan_days - b.min_plan_days)

    }
    else {
      feed = login.notifications.sort((a,b) => b.id - a.id)
      console.log({feed})
    }

    this.datedItems = feed.filter((a) => a.fixed_date)
    let nonDated = feed.filter((a) => !a.fixed_date)

    feed = nonDated.map((a) => ({...a, day: a.min_plan_days }))
    this.items = feed;

    this.inited = true;
  },

  computed : {


  },

  methods : {
    t,

    onUploadProfileImage() {
      this.$router.push('/plan/profile?upload_avatar=1')
    },

    onUploadSecondProfileImage() {
      this.$router.push('/plan/profile')
    },

    setDates(planStartDate, daysInPlan) {
        let d = planStartDate.replace(/ /g,"T")
        if (d) {
            let subDate = new moment(d).toDate(),
                today = new Date()

            today.setHours(12);
            today.setMinutes(0);
            today.setSeconds(0);

            subDate.setHours(12);
            subDate.setMinutes(0);
            subDate.setSeconds(0);


            if (today - subDate >= 0 || 2 > 1) this.planStarted = true
            else {
                this.planStartDate = subDate.getDate() + '/' + (subDate.getMonth() + 1) + '/' + subDate.getFullYear()
            }
            this.planStartDateRaw = this.dateStr(subDate)
            this.daysInPlan = daysInPlan
        }
    },

    dateStr(date) {
      date = new Date(date);
      let s = date.getFullYear() + '-'
      if (date.getMonth() < 10) s += '0';
      s += (date.getMonth()+1) + '-'
      if (date.getDate() < 10) s += '0';
      s += date.getDate();

      return s;
    },

    onQuizClick(day) {
      this.$router.push('/plan/quiz/'+day)
    },

    onWeightingClick(day) {
      this.$router.push('/plan/weighting/'+day)
    },

    onMeasurementClick(day) {
      this.$router.push('/plan/measurement/'+day)
    },

    async onToggleWatchVideo(day) {
        if (this.watchedVideos.indexOf(day) === -1) {
          await Fito().RunAction('watch-daily-lesson', {day})
          this.watchedVideos.push(day)
        }
        else {
          await Fito().RunAction('unwatch-daily-lesson', {day})
          this.watchedVideos = this.watchedVideos.filter(it => it !== day)
        }
    }
  },

}
</script>
